import { configureStore } from '@reduxjs/toolkit';
import statusReducer from '../slices/statusSlice';
import { crmAPI } from '../services/crmAPI';
import { noLoadingReqAPI } from '../services/noLoadingReqAPI';

export const store = configureStore({
    reducer: {
        [crmAPI.reducerPath]: crmAPI.reducer,
        [noLoadingReqAPI.reducerPath]: noLoadingReqAPI.reducer,
        status: statusReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(crmAPI.middleware, noLoadingReqAPI.middleware),
})